require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonItem = exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _theming = require("../../core/theming");

var _RadioButtonGroup = require("./RadioButtonGroup");

var _utils = require("./utils");

var _TouchableRipple = _interopRequireDefault(require("../TouchableRipple"));

var _RadioButton = _interopRequireDefault(require("./RadioButton"));

var _Text = _interopRequireDefault(require("../Typography/Text"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/RadioButton/RadioButtonItem.tsx";

var RadioButtonItem = function (_React$Component) {
  (0, _inherits2["default"])(RadioButtonItem, _React$Component);

  function RadioButtonItem() {
    (0, _classCallCheck2["default"])(this, RadioButtonItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioButtonItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(RadioButtonItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          label = _this$props.label,
          style = _this$props.style,
          labelStyle = _this$props.labelStyle,
          onPress = _this$props.onPress,
          disabled = _this$props.disabled,
          color = _this$props.color,
          uncheckedColor = _this$props.uncheckedColor,
          status = _this$props.status,
          colors = _this$props.theme.colors;
      return React.createElement(_RadioButtonGroup.RadioButtonContext.Consumer, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      }, function (context) {
        return React.createElement(_TouchableRipple["default"], {
          onPress: disabled ? undefined : function () {
            return (0, _utils.handlePress)({
              onPress: onPress,
              onValueChange: context === null || context === void 0 ? void 0 : context.onValueChange,
              value: value
            });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 116
          }
        }, React.createElement(_reactNative.View, {
          style: [styles.container, style],
          pointerEvents: "none",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128
          }
        }, React.createElement(_Text["default"], {
          style: [styles.label, {
            color: colors.text
          }, labelStyle],
          __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        }, label), React.createElement(_RadioButton["default"], {
          value: value,
          disabled: disabled,
          status: status,
          color: color,
          uncheckedColor: uncheckedColor,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        })));
      });
    }
  }]);
  return RadioButtonItem;
}(React.Component);

exports.RadioButtonItem = RadioButtonItem;
(0, _defineProperty2["default"])(RadioButtonItem, "displayName", 'RadioButton.Item');

var _default = (0, _theming.withTheme)(RadioButtonItem);

exports["default"] = _default;

var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 16
  },
  label: {
    fontSize: 16
  }
});